'use es6';

import { PureComponent, Fragment } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { getPropertyObjectTypeId } from 'FormsUI/utils/PropertiesUtils';
import { CommentableArea } from 'collaboration-sidebar';
import getMetaDataValue from 'forms-utils-lib/formField/utils/getMetaDataValue';
import updateMetaData from 'forms-utils-lib/formField/utils/updateMetaData';
import { Spacer } from 'foundations-components/components/Spacer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const langKey = suffix => `editor.form.config.${suffix}`;
const MULTIPLE_FILE_KEY = 'isMultipleFileUpload';
export default class File extends PureComponent {
  renderAllowMultiple() {
    const {
      field,
      update
    } = this.props;
    const isMultiple = getMetaDataValue(field, MULTIPLE_FILE_KEY) === 'true';
    return /*#__PURE__*/_jsx(CommentableArea, {
      moduleId: `${getPropertyObjectTypeId(field)}-allow-multiple`,
      description: {
        translationKey: 'formsAllowMultiple'
      },
      children: /*#__PURE__*/_jsx("div", {
        "data-test-id": "config-input-field-multiple-files",
        children: /*#__PURE__*/_jsx(Checkbox, {
          checked: isMultiple,
          id: "multiple-files",
          onChange: () => update(updateMetaData(field, MULTIPLE_FILE_KEY, `${!isMultiple}`)),
          size: "small",
          "data-editable-field": "allow-multiple-files",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: langKey('multipleFiles')
          })
        })
      })
    });
  }
  render() {
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [this.props.RequiredField, this.props.HiddenField, this.props.LabelField, /*#__PURE__*/_jsx(Spacer, {}), this.props.HelpTextField, /*#__PURE__*/_jsx(Spacer, {}), this.props.ProfillingField, /*#__PURE__*/_jsx(Spacer, {}), this.renderAllowMultiple()]
    });
  }
}